import { render, staticRenderFns } from "./WODistintaBase.vue?vue&type=template&id=d27280ea&"
import script from "./WODistintaBase.vue?vue&type=script&lang=js&"
export * from "./WODistintaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports